import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import CompanyVerificationRequestModal from '../Application/Components/Modals/CompanyVerificationRequestModal';
import { composeDisplayName } from '../Application/Helpers/applicantHelper';
import useCompanyStore from '../../stores/companyStore'; // Adjust path as needed
import useAuthStore from '../../stores/authStore';

const SidebarUserBlock = () => {
  const { t } = useTranslation();
  const [showUserBlock] = useState(true);
  const [isCompanyVerificationModalOpen, setIsCompanyVerificationModalOpen] = useState(false);
  const user = useAuthStore((state) => state.user);
  const company = useCompanyStore((state) => state.company);

  /* global VERSION */
  const version = typeof VERSION !== 'undefined' ? VERSION : 'dev';

  const showUserImage = () => {
    if (!user || !user.photoUrl) {
      return 'img/user/user-dummy-300x300.png';
    }
    return user.photoUrl;
  };

  const printRoles = () => {
    if (user && user.roles) {
      return user.roles.join(' ');
    }
    return 'No Roles found!';
  };

  const renderCompanyStatus = () => {
    if (!company) return null;
    switch (company.companyStatus) {
      case 'New':
        return (
          <span
            onClick={() => setIsCompanyVerificationModalOpen((v) => !v)}
            className="user-block-role icon-hover-effect-no-color"
          >
            <i className="icon-shield mr-1" style={{ color: 'orange' }}></i>
            {t('dashboard.VERIFY_COMPANY')}
          </span>
        );
      case 'WaitingForVerification':
        return (
          <span className="user-block-role">
            <i className="icon-check mr-1" style={{ color: 'orange' }}></i>
            {t('dashboard.WAITING_VERIFICATION')}
          </span>
        );
      case 'Verified':
        return (
          <span className="user-block-role">
            <i className="icon-check mr-1" style={{ color: 'green' }}></i>
            {t('dashboard.VERIFIED')}
          </span>
        );
      case 'Rejected':
        return (
          <span className="user-block-role">
            <i className="icon-shield" style={{ color: 'red' }}></i> {t('dashboard.REJECTED')}
          </span>
        );
      default:
        return null;
    }
  };

  return (
    <Collapse id="user-block" isOpen={showUserBlock}>
      <div>
        <CompanyVerificationRequestModal
          isCompanyVerificationModalOpen={isCompanyVerificationModalOpen}
          toggleIsCompanyVerificationModalOpen={() => setIsCompanyVerificationModalOpen((v) => !v)}
        />
        <div className="item user-block" style={{ cursor: 'default' }}>
          {/* User picture */}
          <div className="user-block-picture">
            <div className="user-block-status">
              <img className="img-thumbnail rounded-circle" src={showUserImage()} alt="Avatar" width="60" height="60" />
              <div className="circle bg-success circle-lg"></div>
            </div>
          </div>
          {/* Name and Job */}
          <div className="user-block-info">
            <span className="user-block-name">
              {user && user.unique_name ? composeDisplayName(user) : 'Not Logged in'}
            </span>
            <span className="user-block-role">
              {printRoles()}, v.{version}
            </span>
            {renderCompanyStatus()}
          </div>
        </div>
      </div>
    </Collapse>
  );
};

export default SidebarUserBlock;
